/* eslint-disable no-restricted-syntax */
/* eslint-disable no-use-before-define */
import React, { useState, useEffect, useLayoutEffect, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import produce from 'immer';
// context
import StepperContext from '../../components/molecules/Stepper/StepperContext';
import LoaderContext from '../../components/molecules/Loader/LoaderContext';
// configs
import routes from '../../../application/config/routes';
// models
import contractsUiModel from './uiModel';
// components
import ContractsTemplate from '../../components/templates/ContractsTemplate/ContractsTemplate';
// actions
import { signatureActions } from '../../../application/actions/signature';
import { paymentButtonActions } from '../../../application/actions/paymentButton';
import { documentsActions } from '../../../application/actions/documents';
// utils
import { comesFromValidPreviousPath } from '../../utils/redirect';
import { isMobile } from '../../utils/platform';
import { isInRange } from '../../../domain/utils/utilitarios-frontend-coopeuch/number';
import { saveAllEntitiesToStorage, saveAllEntitiesFromStorage } from '../../utils/storage';

import { isArray } from '../../../domain/utils/utilitarios-frontend-coopeuch/array';
import { generateDownloadDocument } from '../../../domain/utils/utilitarios-frontend-coopeuch/file';
import sendAnalitycs from '../../../domain/utils/utilitarios-frontend-coopeuch/Analytics';
import dataLayerObject from '../../../domain/utils/dataLayerObject';

import { useModal } from '../../hooks/useModal';

import edgeCases from '../../localData/edgeCases';
import messagesInputAuthSms from './data/messagesInputAuthSms';

// data
import contractsData from '../../../db/contracts.json';

const isDeviceMobile = isMobile();

const Contracts = () => {
  const [monthlyFees, setMonthlyFees] = useState({ ...contractsUiModel.monthlyFees });
  const [monthlyInvestment, setMonthlyInvestment] = useState({
    ...contractsUiModel.monthlyInvestment,
  });
  const [bank, setBank] = useState({ ...contractsUiModel.bank });
  const [banksItemsIterated, setBanksItemsIterated] = useState([]);
  const [accountType, setAccountType] = useState({ ...contractsUiModel.accountType });
  const [accountsTypesItemsIterated, setAccountsTypesItemsIterated] = useState([]);
  const [accountNumber, setaccountNumber] = useState({ ...contractsUiModel.accountNumber });

  const [isValidMonthlyFee, setIsValidMonthlyFee] = useState(true);
  const [termsAndConditions, setTermsAndConditions] = useState({
    ...contractsUiModel.termsAndConditions,
  });
  const [inputCodeSMS, setInputCodeSMS] = useState({ ...contractsUiModel.inputCodeSMS });
  // COMMENT: steps: initial, loading, input  ---  cases: available, timeExpired, incorretCode, locked
  const [stateAuthSms, setStateAuthSms] = useState({
    step: 'initial',
    case: 'none',
  });

  const [isValidStep, setIsValidStep] = useState(false);

  const [isCompletedCardParticipationFees, setIsCompletedCardParticipationFees] = useState(false);
  const [isCompletedCardBankAccount, setIsCompletedCardBankAccount] = useState(false);
  const [isCompletedCardTermsAndConditions, setIsCompletedCardTermsAndConditions] = useState(false);
  const [isCompletedCardElectronicSignature, setIsCompletedCardElectronicSignature] =
    useState(false);

  const [isOpenModalEdgeCase, openModalEdgeCase, closeModalEdgeCase] = useModal(false);
  const [currentEdgeCase, setCurrentEdgeCase] = useState({
    title: '',
  });
  const [visibilityWarningMessage, setVisibilityWarningMessage] = useState(false);
  
  const appRoutes = routes();
  const history = useHistory();
  const dispatch = useDispatch();

  const participationFeesParams = useSelector((store) => store.entities.participationFees);
  const banksItems = useSelector((store) => store.entities.banks.data);
  const accountsTypesItems = useSelector((store) => store.entities.accountsTypes.data);
  const document = useSelector((store) => store.entities.documents.document);
  const fetchSignature = useSelector((store) => store.entities.signature.fetchSignature);
  const validateSignature = useSelector((store) => store.entities.signature.validateSignature);
  const storeAbono = useSelector((store) => store.entities?.abonoInicial?.data);
  

  const generatePaymentButton = useSelector(
    (store) => store.entities.paymentButton.generatePaymentButton
  );
  const confirmPaymentButton = useSelector(
    (store) => store.entities.paymentButton.confirmPaymentButton
  );
  const isLoadingFetchSignature = useSelector((store) => store.ui.loaders.isLoadingFetchSignature);
  const isLoadingValidateSignature = useSelector(
    (store) => store.ui.loaders.isLoadingValidateSignature
  );
  
  const isLoadingConfirmPaymentButton = useSelector(
    (store) => store.ui.loaders.isLoadingConfirmPaymentButton
  );

  const [isOpenModalAbandonmentSurvey, setIsOpenModalAbandonmentSurvey, closeModalAbandonmentSurvey] = useModal(false);


  const stateFields = (dataType) => {
    const fields = {
      monthlyFees,
      monthlyInvestment,
      bank,
      accountType,
      accountNumber,
      termsAndConditions,
      inputCodeSMS,
    };
    /* istanbul ignore next */
    return dataType === 'array' ? Object.values(fields) : { ...fields };
  };

  const stateMap = {
    monthlyFees: {
      state: monthlyFees,
      seter: setMonthlyFees,
    },
    monthlyInvestment: {
      state: monthlyInvestment,
      seter: setMonthlyInvestment,
    },
    bank: {
      state: bank,
      seter: setBank,
    },
    accountType: {
      state: accountType,
      seter: setAccountType,
    },
    accountNumber: {
      state: accountNumber,
      seter: setaccountNumber,
    },
    termsAndConditions: {
      state: termsAndConditions,
      seter: setTermsAndConditions,
    },
    inputCodeSMS: { state: inputCodeSMS, seter: setInputCodeSMS },
  };

  const entitiesInCard = {
    CardParticipationFees: [monthlyFees],
    CardBankAccount: [bank, accountType, accountNumber],
    CardTermsAndConditions: [termsAndConditions],
    CardElectronicSignature: [inputCodeSMS],
  };

  const getCompletedCard = (cardName) => {
    return entitiesInCard[cardName]
      .filter((el) => el.isVisible)
      .map((el) => {
        if (el.name === 'monthlyFees')
          return isInRange(el.value, {
            min: participationFeesParams.minMonthlyFee,
            max: participationFeesParams.maxMonthlyFee,
          });
        return el.isValid(el.value) && el.errors.length === 0;
      })
      .every((val) => val === true);
  };

  const { handleChangeStep } = useContext(StepperContext);
  const { handleChangeLoading } = useContext(LoaderContext);
  const phone = sessionStorage.getItem('phone');
  /* istanbul ignore next */
  useLayoutEffect(() => {
    console.log("####### ***** UseLayoutEffect ***** ########")
    if (String(sessionStorage.getItem('correctStep')) === 'wp') {
      console.log("##### correctStep = wp ----- VIENE DE VIENE DE WEPBAY");
      // COMMENT: VIENE DE WEPBAY
      const queryParams = new URLSearchParams(history.location.search);
      if (history.location.search !== '') {
        console.log("##### correctStep = wp - tiene parámetros en la url");
        // COMMENT: Tiene queryparams
        const tbkToken = queryParams.get('TBK_TOKEN') || '';
        const tokenWs = queryParams.get('token_ws') || '';
        if (tbkToken !== '' || tokenWs !== '') {
          console.log("##### correctStep = 2 ----- VIENE DE WEPBAY ya que url tiene parámetros y llegan variables tbkToken o tokenWs - SE LLAMA AL SERVICIO PAGO CONFIRMAR");
          const payloadConfirmationPayment = {
            tokenWP: tbkToken || tokenWs,
            flowDetail: tbkToken ? 'aborted' : 'transaction',
          };
          dispatch(paymentButtonActions.confirmPaymentButton(payloadConfirmationPayment));
          }  else {
          console.log("##### CASO BORDE NO CONTROLADO: viene de webpay,  correctStep = wp ---  QUERYPARAMS  NO SON LOS ESPERADOS DE WEBPÀY: otros parametros desde webpay o alguien escribio query params en la url y regrescó la pagina")
        }
      } else {
        console.log("##### correctStep = wp -  viene de Webpay pero sin parametros, posiblmente se hizo click en el boton ATRAS - seteamos correctStep = 2");
        sessionStorage.setItem('correctStep', String(2))
        // TODO: mejorar esta ya se se hace un scroll despues de 2 segundos, la idea es hacerlo despues de cargar todos los componentes
        console.log("##### En algunos navegadores el correct step no afecta los otros efectos y los fetching true de los servicios se mantiene, por ello aquí apagamos el loader si sigue activo")
      }
    } else if (String(sessionStorage.getItem('correctStep')) === '2') {
      console.log("##### correctStep = 2 - viene del paso 1 o estuvo en el paso 2 y se actualizó la pagina")
      sendAnalitycs(dataLayerObject.PERSONAL_BIOMETRY_SUCCESS);
      sendAnalitycs(dataLayerObject.CONTRATING_PAYMENT_LOADED);
    } else if (String(sessionStorage.getItem('correctStep')) === '3') {
      // COMMENT: ya había llegado al paso 3 he hizo muchas veces en el boton de atras hasta dar con el paso 2 (paso por interfaces de webpay)
      console.log("######### correctStep = 2 ----- ya había llegado al paso 3 he hizo muchas veces en el boton de atras hasta dar con el paso 2 (paso por interfaces de webpay) - SI ES ASI LO VOLVEMOS A MANDAR AL PASO 3 COMPROBANTE")
      history.push(appRoutes.summary.path, { from: '/contratacion-pago' });

    } else if (!comesFromValidPreviousPath(appRoutes, history.location)) {
      console.log("######### correctStep no es ni 2 ni 3 - Por si alguien se quiere saltear a este paso escribiendo el dominio y el path de contractacion, se lo redirecciona al paso 1")
      // COMMENT: Por si alguien se quiere saltear a este paso escribiendo el dominio y el path de contractacion
      history.push(appRoutes.index.path);
    }
  }, []);

  useEffect(() => {
    handleChangeStep(2);
    window.scrollTo({ top: 0 });
  }, []);

  useEffect(() => {
    if (banksItems.length > 0) {
      setBanksItemsIterated(
        banksItems.map((bankLitle) => {
          return { value: bankLitle.codigo, label: bankLitle.descripcion };
        })
      );
    }
  }, [banksItems]);

  useEffect(() => {
    if (accountsTypesItems.length > 0) {
      setAccountsTypesItemsIterated(
        accountsTypesItems.map((acountTypeLitle) => {
          return { value: acountTypeLitle.codigo, label: acountTypeLitle.descripcion };
        })
      );
    }
  }, [accountsTypesItems]);

  useEffect(() => {
    /* istanbul ignore next */
    if (!isOpenModalEdgeCase && currentEdgeCase.title !== '') setCurrentEdgeCase({ title: '' });
  }, [isOpenModalEdgeCase]);

  useEffect(() => {
    if (dataLayerObject[currentEdgeCase.casesDataLayer])
      /* istanbul ignore next */
      sendAnalitycs(dataLayerObject[currentEdgeCase.casesDataLayer]);
  }, [currentEdgeCase])

  useEffect(() => {
    /* istanbul ignore next */
    if (isLoadingFetchSignature === true) setStateAuthSms({ step: 'loading', case: 'none' });
    else if (fetchSignature?.success === true) {
      // TODO: revisar si es necesario validar fetchSignature con ?
      /* istanbul ignore next */
      setStateAuthSms({ step: 'input', case: 'available' });
      resetInputCodeSMS();
    }
  }, [isLoadingFetchSignature]);

  useEffect(() => {
    if (isLoadingValidateSignature === true) {
      /* istanbul ignore next */
      handleChangeLoading(isLoadingValidateSignature);
    }
  }, [isLoadingValidateSignature]);

  // COMMENT: La activacion del loader se hizo en la validacion de la firma, y se mantiene activa hasta ir a webpay, por ello comentamos el efecto sieguiente
  useEffect(() => {
    console.log("🚀 ~ file: Contracts.js:287 ~ useEffect ~ isLoadingConfirmPaymentButton:", isLoadingConfirmPaymentButton)
    if (isLoadingConfirmPaymentButton === true) {
      /* istanbul ignore next */
      handleChangeLoading(isLoadingConfirmPaymentButton);
    }
    // COMMENT: pos asincronía no se alcanza a llegar a desactivar el loadin, entonces solo lo prendemos arriba cuando se esta llamando al servicio y esperando la respuesta
  }, [isLoadingConfirmPaymentButton]);
  /* istanbul ignore next */
  useEffect(() => {
    if (fetchSignature.success === true) {
      setStateAuthSms({ step: 'input', case: 'available' });
    } else if (fetchSignature.error === true) {
      sendAnalitycs(dataLayerObject.BORDE_SIGNATURE_REQUEST_ERROR);
      // COMMENT: antes se presionaba reintentar desde el mismo modal, pero era bucle infinito si el servicio sigue dando error
      // Ahora se muestra un modal y se cierra para presionar otra vez el boton azul o salir
      setStateAuthSms({ step: 'initial', case: 'none' });
      openModalEdgeCase();
      setCurrentEdgeCase(edgeCases.canNotShowElectronicSignature);
      if (fetchSignature.code === '104'){
        setCurrentEdgeCase(edgeCases.limitHorario);
      }
    } 
  }, [fetchSignature]);
  /* istanbul ignore next */
  useEffect(() => {
    console.log("🚀 ~ file: Contracts.js:315 ~ useEffect ~ sessionStorage.getItem('correctStep'):", sessionStorage.getItem('correctStep'))
    if (String(sessionStorage.getItem('correctStep')) !== 'wp') {
      console.log("🚀 ~ file: Contracts.js:317 ~ useEffect ~ validateSignature:", validateSignature)
      if (validateSignature.success) {
        console.log("🚀 ~ file: Contracts.js:319 ~ useEffect ~ validateSignature.success:", "########## - Despues de validar el sms llamamos al servicio generar para el commit inicial con transbamk y obtener la url para ir a pagar")
        dispatch(paymentButtonActions.generatePaymentButton(Object.freeze({})));
      } else if (validateSignature.error) {
        handleChangeLoading(false); // COMMENT: Considerando que dejamos el loading activo hasta ir a webpay, si esto falla deberiamos detener el loading
        if (validateSignature.code === '53') {
          // COMMENT: para el caso que el codigo sms es incorrecto
          setStateAuthSms({ step: 'input', case: 'incorretCode' });
          sendAnalitycs(dataLayerObject.BORDE_SEND_SMS_INCORRET_CODE);
        } else if (validateSignature.code === '54') {
          // COMMENT: para el caso de bloqueo por intentos fallidos
          setStateAuthSms({ step: 'input', case: 'locked' });
          const nextState = produce((draft) => {
            draft.value = ['', '', '', '', '', ''];
            draft.disabled = true;
          });
          setInputCodeSMS(nextState);
          sendAnalitycs(dataLayerObject.BORDE_SEND_SMS_LOCKED);
        } else if (validateSignature.error) {
          setStateAuthSms({ step: 'input', case: 'retry' });
          const nextState = produce((draft) => {
            draft.value = ['', '', '', '', '', ''];
            draft.disabled = true;
          });
          setInputCodeSMS(nextState);
          openModalEdgeCase();
          setCurrentEdgeCase(edgeCases.errorOcurredStep2);
        }
      }
    }
  }, [validateSignature]);
  /* istanbul ignore next */
  useEffect(() => {
    console.log("🚀 ~ file: Contracts.js:351 ~ useEffect ~ generatePaymentButton:", generatePaymentButton)
    if (generatePaymentButton.success === true && generatePaymentButton.url && String(sessionStorage.getItem('correctStep')) !== 'wp') {
      saveAllEntitiesToStorage(stateFields('object'), ['inputCodeSMS']);
      handleRedirectWebpay(generatePaymentButton.token, generatePaymentButton.url);
    } else if (generatePaymentButton.error === true) {
      handleChangeLoading(false); // COMMENT: Considerando que dejamos el loading activo hasta ir a webpay, si esto falla deberiamos detener el loading
      setStateAuthSms({ step: 'initial', case: 'none' });
      openModalEdgeCase();
      if (generatePaymentButton.code === '90') {
        setCurrentEdgeCase(edgeCases.errorTbkConnection);
      } else if (generatePaymentButton.code === '104') {
        setCurrentEdgeCase(edgeCases.limitHorario);
      } else {
        setCurrentEdgeCase(edgeCases.errorOcurredStep2);
      }
    }
  }, [generatePaymentButton]);
  /* istanbul ignore next */
  useEffect(() => {
    console.log("🚀 ~ file: Contracts.js:368 ~ useEffect ~ confirmPaymentButton:", confirmPaymentButton)
    if (confirmPaymentButton.success === true) {
      // COMMENT: Guaramos los datos de pago en session storage
      sessionStorage.setItem("payment-type", confirmPaymentButton.paymentType)
      sessionStorage.setItem("authorization-code", confirmPaymentButton.authorizationCode)
      sessionStorage.setItem("last-digits-card", confirmPaymentButton.cardNumber)
      sessionStorage.setItem("transaction-date", confirmPaymentButton.transactionDate)
      sessionStorage.setItem("vci",confirmPaymentButton.vci)
      sessionStorage.setItem("accountNumber-socio", confirmPaymentButton.accountNumber)
      sessionStorage.setItem("fecha-retiro",confirmPaymentButton.schedulingOfficeRetreat)
      handleChangeLoading(false); // COMMENT: Por asincronía, esta redireccion es antes que el apagado del loader, por lo que la hacemos aquí antes de ir al paso 3
      sessionStorage.setItem('correctStep', String(3))
      history.push(appRoutes.summary.path, { from: history.location.pathname });
    } else if (confirmPaymentButton.error === true) {
      handleChangeLoading(false); // COMMENT: Por asincronía, esta redireccion es antes que el apado del loader, por lo que la hacemos aquí antes de ir al paso 3
      // COMMENT: Por ahora todos los casos borde son no bloquenates, cuando haya diferenciacin, refactorizar y mover esto
      // COMMENT: obteemos datos de controles desde el session storae y preseleccionamos
      const valuesFromStorageToSave = saveAllEntitiesFromStorage(stateFields('object'), [
        'termsAndConditions',
        'inputCodeSMS',
      ]);
      valuesFromStorageToSave.forEach((entity) => {
        const nextState = produce((draft) => {
          draft.value = entity.value;
        });
        stateMap[entity.key].seter(nextState);
      });
      if (confirmPaymentButton.code === '91') {
        // PAGO NO PROCESADO NO BLOQUEANTE
        openModalEdgeCase();
        setCurrentEdgeCase(edgeCases.errorPaymentDeclined);
        sendAnalitycs(dataLayerObject.BORDE_DECLINED_PAYMENT);
      } else if (confirmPaymentButton.code === '92') {
        // PAGO ABORTADO POR EL USUARIO
        setVisibilityWarningMessage(true);
        sendAnalitycs(dataLayerObject.BORDE_CANCELED_PAYMENT);
      } else {
        openModalEdgeCase();
        setCurrentEdgeCase(edgeCases.errorOcurredStep2); // ERROR GENERICO NO BLOQUEANTE
      }
    }
  }, [confirmPaymentButton]);

  useEffect(() => {
    if (document) {
      /* istanbul ignore next */
      generateDownloadDocument(
        document.nombre,
        document.documento,
        document.tipo,
        document.codificacion
      );
    }
  }, [document]);

  useEffect(() => {
    if (participationFeesParams.successFetching === true) {
      const tempMonthlyFee = sessionStorage.getItem('monthly-fees')
        ? parseInt(sessionStorage.getItem('monthly-fees'), 10)
        : parseInt(participationFeesParams.minMonthlyFee, 10);
      const nextStateMonthlyFee = produce((draft) => {
        draft.value = tempMonthlyFee;
      });
      const nextStateMonthlyInvestment = produce((draft) => {
        draft.value = tempMonthlyFee * participationFeesParams.value;
      });
      setMonthlyFees(nextStateMonthlyFee);
      setMonthlyInvestment(nextStateMonthlyInvestment);
      sessionStorage.setItem("fee-value", participationFeesParams.value)
    }
  }, [participationFeesParams]);

  useEffect(() => {
    const nextState = produce((draft) => {
      draft.value = participationFeesParams.value * monthlyFees.value;
    });
    setMonthlyInvestment(nextState);
    setIsCompletedCardParticipationFees(getCompletedCard('CardParticipationFees'));
  }, [monthlyFees]);

  useEffect(() => {
    setIsCompletedCardBankAccount(getCompletedCard('CardBankAccount'));
  }, [bank, accountType, accountNumber]);

  useEffect(() => {
    setIsCompletedCardTermsAndConditions(getCompletedCard('CardTermsAndConditions'));
  }, [termsAndConditions]);

  useEffect(() => {
    setIsCompletedCardElectronicSignature(getCompletedCard('CardElectronicSignature'));
  }, [inputCodeSMS]);

  useEffect(() => {
    setIsValidStep(
      isCompletedCardBankAccount &&
      isCompletedCardParticipationFees &&
      isCompletedCardTermsAndConditions &&
      isCompletedCardElectronicSignature &&
      stateAuthSms.step === 'input' &&
      (stateAuthSms.case === 'available' || stateAuthSms.case === 'incorretCode')
    );
  }, [
    isCompletedCardBankAccount,
    isCompletedCardParticipationFees,
    isCompletedCardTermsAndConditions,
    isCompletedCardElectronicSignature,
  ]);
  /* istanbul ignore next */
  const isValidField = (field, value) => {
    const anotherValidation = stateMap[field].state.anotherValidation
      ? Object.values(stateMap[field].state.anotherValidation).every((v) => v === true)
      : true;
    return stateMap[field].state.isValid(value) && anotherValidation;
  };
  /* istanbul ignore next */
  const handleChangeField = ({ field, property, value, extra }) => {
    let finalValue;
    const generateErrorsList = (val) => {
      const errors = [];

      if (!isValidField(field, val))
        errors.push({ text: 'El formato ingresado es incorrecto', type: 'error' });
      return errors;
    };

    if (field === 'monthlyFees') {
      const isValidRange = isInRange(value, {
        min: participationFeesParams.minMonthlyFee,
        max: participationFeesParams.maxMonthlyFee,
      });
      setIsValidMonthlyFee(isValidRange);
      finalValue = value.replace(/\D/g, '');
    } else if (field === 'accountNumber') {
      finalValue = value.replace(/\D/g, '');
    } else finalValue = value;

    const errorsList = property === 'value' ? generateErrorsList(finalValue) : [];

    const nextState = produce((draft) => {
      if (isArray(stateMap[field].state)) {
        draft[extra.index][property] = finalValue;
        draft[extra.index].errors = errorsList;
      } else {
        draft[property] = finalValue;
        draft.errors = errorsList;
      }
    });
    stateMap[field].seter(nextState);
  };
  /* istanbul ignore next */
  const handleChangeCustom = (name, type, segment) => {
    const documentsPayload = {
      nombre: name,
      tipo: type,
      segmento: segment,
    };
    dispatch(documentsActions.fetchCustomDocuments(documentsPayload))
  }

  const handleDownloadContract = (name, type, segment) => {
    /* istanbul ignore next */
    sendAnalitycs(dataLayerObject.CONTRATING_PAYMENT_DOWNLOAD_CONTRACT, [
      {
        key: 'eve-lab',
        param: 'nombre-documento',
        value: name,
      },
    ]);
    const documentsPayload = {
      nombre: name,
      tipo: type,
      segmento: segment,
    };
    /* istanbul ignore next */
    dispatch(documentsActions.fetchGenericDocuments(Object.freeze(documentsPayload)));
  };
  /* istanbul ignore next */
  const resetInputCodeSMS = (disabled = false) => {
    handleChangeField({
      field: 'inputCodeSMS',
      property: 'value',
      value: ['', '', '', '', '', ''],
    });
    handleChangeField({
      field: 'inputCodeSMS',
      property: 'disabled',
      value: disabled,
    });
  };
  /* istanbul ignore next */
  const handleInvokeAuthSms = () => {
    sendAnalitycs(dataLayerObject.CONTRATING_PAYMENT_TO_FINAL_STEP_BUTTON, [
      {
        key: 'eve-lab',
        param: 'texto-boton',
        value: 'Enviar clave por SMS',
      },
    ]);
    if (fetchSignature.error) {
      // showModal(false);
      // TODO:'PENDIENTE MOSTRAR MODAL CASO BORDE');
    }
    dispatch(signatureActions.fetchSignature());
  };
  /* istanbul ignore next */
  const handleTimeOverToRespond = () => {
    setStateAuthSms({ step: 'input', case: 'timeExpired' });
    resetInputCodeSMS(true);
  };
  /* istanbul ignore next */
  const handleContinueFlow = () => {
    // COMMENT: Algunos navegaroes al retroceder de otra pagina, como webpay, no ejecuta javascript, por lo que el navegador queda tal y como quedó...
    // Felizmente esta funcion se detona por una interaccion, por lo que aquellos navegadores que mantengan correctState = 'wp' podemos detectarlo acá
    // Si ese fuera el caso, seteamos el valor a 2
    if (String(sessionStorage.getItem('correctStep')) === 'wp') sessionStorage.setItem('correctStep', '2')

    const tempItemAccountTypeSeleced = accountsTypesItems.filter(item => String(item.codigo) === String(accountType.value.codigo))[0];

    sendAnalitycs(dataLayerObject.CONTRATING_PAYMENT_TO_FINAL_STEP_BUTTON, [
      {
        key: 'eve-lab',
        param: 'texto-boton',
        value: 'Ir al pago',
      }
    ]);

    const payloadValidateSignature = {
      code: inputCodeSMS.value.join(''),
      accountNumber: String(accountNumber.value),
      accountType: {
        code: String(accountType.value.codigo),
        referenceCode: tempItemAccountTypeSeleced.codigoReferencia,
      },
      bankingEntity: {
        code: bank.value.codigo,
        description: String(bank.value.descripcion),
      },
      fees: monthlyFees.value,
    };
    // console.log(payloadValidateSignature)
    dispatch(signatureActions.validateSignature(payloadValidateSignature));
  };

  const handleCancelFlow = () => {

    sendAnalitycs(dataLayerObject.CONTRATING_PAYMENT_TO_FINAL_STEP_BUTTON, [
      {
        key: 'eve-lab',
        param: 'texto-boton',
        value: 'Cancelar',
      }
    ]);

    setIsOpenModalAbandonmentSurvey(true);
    sendAnalitycs(dataLayerObject.SURVEY_ABANDONMENT_LOAD, [
      {
        key: 'page',
        param: 'paso',
        value: window.location.pathname,
      },
    ]);
  };

  /* istanbul ignore next */
  const handleActionButtonCaseBorder = () => {
    if (dataLayerObject[`${currentEdgeCase.casesDataLayer}_UNDERSTOOD`])
      sendAnalitycs(dataLayerObject[`${currentEdgeCase.casesDataLayer}_UNDERSTOOD`]);
    closeModalEdgeCase();
  };
  /* istanbul ignore next */
  const handleRedirectWebpay = (token, url) => {
    const form = window.document.createElement('form');
    const element1 = window.document.createElement('input');
    form.method = 'POST';
    form.action = url;
    element1.type = 'hidden';
    element1.value = token;
    element1.name = 'token_ws';
    form.appendChild(element1);
    window.document.body.appendChild(form);
    form.submit();
    sessionStorage.setItem('correctStep', "wp")
    handleChangeLoading(false);
  };

  return (
    <ContractsTemplate
      isMobileDevice={isDeviceMobile}
      visibilityWarningMessage={visibilityWarningMessage}
      participationFeesParams={participationFeesParams}
      monthlyFees={monthlyFees}
      monthlyInvestment={monthlyInvestment}
      isValidMonthlyFee={isValidMonthlyFee}
      bank={bank}
      accountType={accountType}
      accountNumber={accountNumber}
      banksItems={banksItemsIterated}
      accountsTypesItems={accountsTypesItemsIterated}
      contracts={contractsData.data}
      onDownloadContract={handleDownloadContract}
      termsAndConditions={termsAndConditions}
      isCompletedCardParticipationFees={isCompletedCardParticipationFees}
      isCompletedCardBankAccount={isCompletedCardBankAccount}
      isCompletedCardTermsAndConditions={isCompletedCardTermsAndConditions}
      isOpenModalEdgeCase={isOpenModalEdgeCase}
      isOpenModalAbandonmentSurvey={isOpenModalAbandonmentSurvey}
      closeModalAbandonmentSurvey={closeModalAbandonmentSurvey}
      currentEdgeCase={currentEdgeCase}
      closeModalEdgeCase={closeModalEdgeCase}
      phone={phone}
      inputCodeSMS={inputCodeSMS}
      stateAuthSms={stateAuthSms}
      messagesInputAuthSms={messagesInputAuthSms}
      canContinueFlow={isValidStep}
      onActionButtonCaseBorder={handleActionButtonCaseBorder}
      onChangeField={handleChangeField}
      onInvokeAuthSms={handleInvokeAuthSms}
      onTimeOverToRespond={handleTimeOverToRespond}
      onContinueFlow={handleContinueFlow}
      onCancelFlow={handleCancelFlow}
      handleChangeCustom={handleChangeCustom}
      validateSignature={validateSignature}
      abono={storeAbono}
    />
  );
};

export default Contracts;